import { usePanorama } from '@wix/fe-essentials/react';
import { useCallback } from 'react';
export const usePanoramaFunctions = () => {
  const panoramaClient = usePanorama();
  const startPanoramaTransaction = useCallback((transactionName, data) => {
    try {
      panoramaClient.transaction(transactionName).start({
        ...data
      });
    } catch (e) {
      console.error(e);
    }
  }, [panoramaClient]);
  const finishPanoramaTransaction = useCallback((transactionName, data) => {
    try {
      panoramaClient.transaction(transactionName).finish({
        ...data
      });
    } catch (e) {
      console.error(e);
    }
  }, [panoramaClient]);
  const infoLogPanorama = useCallback((message, data) => {
    try {
      panoramaClient.logger().info(message, {
        ...data
      });
    } catch (e) {
      console.error(e);
    }
  }, [panoramaClient]);
  const reportErrorPanorama = useCallback((error, errorName) => {
    panoramaClient.errorMonitor().reportError(error, {
      errorName
    });
  }, [panoramaClient]);
  const reportLoadStart = useCallback(data => {
    panoramaClient.reportLoadStart({
      ...data
    });
  }, [panoramaClient]);
  const reportLoadFinish = useCallback(data => {
    panoramaClient.reportLoadFinish({
      ...data
    });
  }, [panoramaClient]);
  return {
    finishPanoramaTransaction,
    infoLogPanorama,
    reportErrorPanorama,
    reportLoadFinish,
    reportLoadStart,
    startPanoramaTransaction
  };
};
//# sourceMappingURL=use-panorama-functions.js.map